"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create360ViewCircleIcon = void 0;

var create360ViewCircleIcon = function create360ViewCircleIcon(circleOffset) {
  var view360CircleIcon = new Image();
  view360CircleIcon.src = 'https://scaleflex.ultrafast.io/https://scaleflex.api.airstore.io/v1/get/_/2236d56f-914a-5a8b-a3ae-f7bde1c50000/360.svg';
  view360CircleIcon.style.bottom = "".concat(circleOffset, "%");
  view360CircleIcon.className = 'cloudimage-360-view-360-circle';
  return view360CircleIcon;
};

exports.create360ViewCircleIcon = create360ViewCircleIcon;